import { motion } from "framer-motion"
import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

import { easeOut, inView } from "./marketing-motion"

type BentoCardProps = {
  className?: string
  children: ReactNode
  delay?: number
  variant?: "default" | "primary" | "muted" | "lavender" | "lime" | "ink"
  hover?: boolean
}

const variantStyles = {
  default:
    "bg-white text-primary shadow-[0_16px_40px_-24px_rgba(69,24,146,0.18)]",
  primary:
    "bg-primary text-white shadow-[0_20px_50px_-28px_rgba(69,24,146,0.35)]",
  muted: "bg-[#f3f1ec] text-primary",
  lavender: "bg-[#d4c4fc] text-primary",
  lime: "bg-[#efe04a] text-primary",
  ink: "bg-[#1a1a6e] text-white",
} as const

export function BentoCard({
  className,
  children,
  delay = 0,
  variant = "default",
  hover = true,
}: BentoCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={inView}
      transition={{ duration: 0.45, delay, ease: easeOut }}
      whileHover={hover ? { y: -4 } : undefined}
      className={cn(
        "flex flex-col rounded-[2rem] p-6 transition-shadow sm:rounded-[2.5rem] sm:p-8",
        hover && "hover:shadow-[0_24px_56px_-28px_rgba(69,24,146,0.22)]",
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </motion.div>
  )
}
